import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Blog from '../../../components/UI/Blog/Blog';
import Button from '../../../components/UI/Button/Button';

import styles from './SignUpProgress.module.scss';
// import signInImg from '../../../assets/images/signin-img.svg';
import signInImgNew from '../../../assets/images/mojo-login-img/login-image@3x.png';
import normalStatus from '../../../assets/images/mojo-login-img/home-normalstatus-icon.svg';
// import signUpImg from '../../../assets/images/signup-img.svg';
import passwordResetImg from '../../../assets/images/password-reset-img.svg';

import * as actions from '../../../redux/actions/index';

const SignUpProgress = (props) => {
  const { onUpdateSignUpData } = props;
  const [content, setContent] = useState(null);
  const subscriptionDataDict = {
    single: {
      title: 'Single Line Dialer',
      price: 89,
      license: 'single_line_power_dialer_count',
    },
    triple: {
      title: 'Triple Line Dialer',
      price: 139,
      license: 'triple_line_power_dialer_count',
    },
    lead: {
      title: 'Agent Access (Required)',
      price: 10,
      license: 'hosted_lead_management_count',
    },
    mojovoice: {
      title: 'Mojo Voice',
      price: 30,
      license: 'mojo_voice_feature_count',
    },
    callrecording: {
      title: 'Call Recording',
      price: 25,
      license: 'call_recording_feature_count',
    },
    'neighborhood-search': {
      title: 'Neighborhood Search',
      price: 49,
      license: 'neighborhood_search_feature',
    },
    'expired-leads': {
      title: 'Expired Leads',
      price: 50,
      license: 'expired_data_feature',
    },
    fsbo: {
      title: 'For Sale By Owner',
      price: 25,
      license: 'fsbo_data_feature',
    },
    frbo: {
      title: 'For Rent By Owner',
      price: 25,
      license: 'frbo_data_feature',
    },
    'skip-tracer': {
      title: 'Skip Tracer',
      price: 49,
      license: 'reverse_lookup_feature',
    },
    'pre-foreclosures': {
      title: 'Pre-Foreclosures',
      price: 49,
      license: 'pre_foreclosure_data_feature',
    },
  };

  const location = useLocation();

  const { currentStep } = props;
  const systemStatusImg = normalStatus;
  const [systemStatus] = useState('Normal');
  const origin =
    window.location.hostname === 'lb11.mojosells.com'
      ? 'https://www.mojosells.com'
      : 'http://44.244.119.13/';
  const [originPath, setOriginPath] = useState('pricing');

  const getStepClasses = useCallback(
    (stepNumber) => {
      const stepClasses = [styles.SignUpProgressStep];
      if (stepNumber < currentStep) {
        stepClasses.push(styles.SignUpProgressStepPassed);
      } else if (stepNumber === currentStep) {
        stepClasses.push(styles.SignUpProgressStepActive);
      }
      return stepClasses;
    },
    [currentStep]
  );

  const getContent = useCallback(
    (localLocation) => {
      if (localLocation.pathname.includes('sign-up')) {
        document.title = 'Mojo Dialer Sign Up';
        setContent(
          <div className={styles.SignUpProgressLeftContent}>
            <div>
              Join 25,000+ sales professionals already growing their business
              with Mojo.
            </div>
            <div className={styles.SignUpProgressLeftTitle}>
              Your Custom Plan
            </div>
            {getSubscriptionData()}
            <Button
              onClick={() => {
                window.location.href = `${origin}/${originPath}/#price-build-plan`;
              }}
              isBtnPrev
              style={{
                width: '100%',
                borderRadius: '8px',
                textAlign: 'center',
                background: '#FFF',
              }}
            >
              Edit Plan
            </Button>
          </div>
        );
      } else if (
        localLocation.pathname.includes('login') ||
        localLocation.pathname.includes('oauth') ||
        localLocation.pathname.includes('browser_select')
      ) {
        document.title = 'Mojo Dialer Login';
        setContent(
          <>
            <div className={styles.SignUpProgressStatusBlock}>
              <div className={styles.SignUpProgressStatus}> System status:</div>
              <div className={styles.SignUpProgressStatusImage}>
                <img src={systemStatusImg} alt="" />
                {systemStatus}
              </div>
            </div>
            <div className={styles.SignUpProgressTitle}>Mojo Dialer Log In</div>
            <div className={styles.SignUpProgressText}>
              Enter your login details in the fields to the right.
            </div>
            <div className={styles.SignUpProgressImage}>
              <img
                src={signInImgNew}
                alt=""
                style={{ maxWidth: '100%', marginBottom: '-4px' }}
              />
            </div>
            <div className={styles.SignUpProgressBlog}>
              <div className={styles.SignUpProgressBlogHeader}>
                <div>Latest Blog Posts:</div>
                <a
                  className={styles.SignUpProgressBlogLink}
                  href="https://www.mojosells.com/blog/"
                  target="_blank"
                  rel="noreferrer"
                >
                  View all post
                </a>
              </div>
              <div className={styles.SignUpProgressBlogContent}>
                <Blog key="blog_post" />
              </div>
            </div>
          </>
        );
      } else if (localLocation.pathname.includes('password-reset')) {
        document.title = 'Mojo Dialer Reset Password';
        setContent(
          <>
            <div className={styles.SignUpProgressTitle}>Welcome to Mojo</div>
            <div
              className={styles.SignUpProgressImage}
              style={{ marginTop: '60px' }}
            >
              <img src={passwordResetImg} alt="" />
            </div>
          </>
        );
      } else if (
        localLocation.pathname.includes('/integrations/bombbomb/redirect_uri/')
      ) {
        setContent(
          <>
            <div className={styles.SignUpProgressTitle}>Integration</div>
            <div
              className={styles.SignUpProgressImage}
              style={{ marginTop: '60px' }}
            >
              <img src={passwordResetImg} alt="" />
            </div>
          </>
        );
      }
    },
    // eslint-disable-next-line
    [getStepClasses, currentStep]
  );

  const getSubscriptionData = () => {
    const searchParams = new URLSearchParams(location.search);
    setOriginPath(searchParams.get('back-url') || 'pricing');
    // The 3DS resume page is a transient landing zone: Stripe redirects the
    // user here with `payment_intent` / `redirect_status` query params (no
    // subscription keys), and `SignUpResume` immediately navigates on to
    // the saved step. Bouncing to /pricing from here would beat that
    // navigation and break the whole 3DS return flow.
    const isResumeRoute = location.pathname.startsWith('/sign-up/resume');
    let isValid = false;
    const validParams = Array.from(searchParams.entries())
      .filter(
        ([key, value]) => subscriptionDataDict[key] && parseInt(value, 10) > 0
      )
      .map(([key, value]) => {
        const quantity = parseInt(value, 10);
        const { price, license } = subscriptionDataDict[key];
        isValid = true;
        return {
          key,
          title: subscriptionDataDict[key].title,
          unitPrice: price,
          quantity,
          total: quantity * price,
          license,
        };
      });
    console.log('validParams', validParams);
    if (!isValid && !isResumeRoute) {
      window.location.href =
        'http://www.mojosells.com/pricing/#price-build-plan';
    }
    const licenseQuantityDict = validParams.reduce((acc, item) => {
      acc[item.license] = item.quantity;
      return acc;
    }, {});
    console.log('licenseQuantityDict', licenseQuantityDict);
    onUpdateSignUpData(licenseQuantityDict);

    const totalPrice = validParams.reduce((sum, item) => sum + item.total, 0);

    return (
      <div style={{ width: '100%' }}>
        <div className={styles.SignUpProcessSubscriptionContent}>
          {validParams.map((item) => (
            <div key={item.key} className={styles.SubscriptionComponent}>
              <div>
                {![
                  'neighborhood-search',
                  'expired-leads',
                  'fsbo',
                  'frbo',
                  'skip-tracer',
                  'pre-foreclosures',
                ].includes(item.key)
                  ? `${item.title} x ${item.quantity}`
                  : item.title}
              </div>
              <div>${item.total}/month</div>
            </div>
          ))}
        </div>
        {validParams.length > 0 && (
          <div className={styles.TotalPriceBlock}>
            <div className={styles.TotalPriceComponent}>
              <div>Total Monthly Cost:</div>
              <div className={styles.TotalPrice}>${totalPrice}/month</div>
            </div>
          </div>
        )}
      </div>
    );
  };

  useEffect(() => {
    getContent(location);
  }, [getContent, location]);

  return <div className={styles.SignUpProgress}>{content}</div>;
};

const mapStateToProps = (state) => {
  return {
    currentStep: state.signUp.stepNumber,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onUpdateSignUpData: (signUpdata) =>
      dispatch(actions.updateSignUpData(signUpdata)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpProgress);
